import { call, put, select, takeEvery } from 'redux-saga/effects';

import { Action, RequestWithId, Types } from '../ducks';
import { EndpointCreator, IClient, IDeleteActions } from '../interfaces';
import { getEndpoint } from './endpoint';

/**
  @deprecated - https://github.com/SaleCycle/my-salecycle-com#legacy-code 
*/
export function* doDelete<T>(
  client: IClient<T>,
  endpointCreator: EndpointCreator,
  actions: IDeleteActions,
  id: string,
  params?: { [key: string]: string },
) {
  yield put(actions.startDelete(id));

  const endpoint: string = yield select(getEndpoint, endpointCreator, params);
  if (!endpoint) {
    return yield put(actions.failDelete(id, "couldn't delete endpoint"));
  }

  try {
    yield call([client, 'delete'], `${endpoint}/${id}`);
    return yield put(actions.completeDelete(id));
  } catch (error) {
    return yield put(actions.failDelete(id, (error as Error).message));
  }
}

/**
  @deprecated - https://github.com/SaleCycle/my-salecycle-com#legacy-code 
*/
export function newDeleteSaga<T, S>(
  client: IClient<T>,
  endpointCreator: EndpointCreator,
  actions: IDeleteActions,
  service: S,
) {
  const isDeleteRequest = (action: Action<T, S>) =>
    action.type === Types.DELETE_REQUESTED && action.service === service;

  return function*() {
    yield takeEvery(isDeleteRequest as any, (action: RequestWithId<S>) =>
      doDelete(client, endpointCreator, actions, action.payload.id, action.payload.params),
    );
  };
}
